import { updateServiceWorker } from '@/shared/lib/pwa/updateServiceWorker';

const FIRST_CHECK_DELAY_MS = 30_000;
const POLL_INTERVAL_MS = 5 * 60 * 1000;
const VERSION_URL = '/version.json';

export const VERSION_MISMATCH_EVENT = 'axiom:version-mismatch';

let started = false;
let detected = false;
let checking = false;

async function fetchRemoteBuildId(): Promise<string | null> {
  try {
    const res = await fetch(VERSION_URL, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = (await res.json()) as { buildId?: unknown };
    return typeof data.buildId === 'string' ? data.buildId : null;
  } catch {
    return null;
  }
}

async function checkOnce(): Promise<void> {
  if (detected || checking) return;
  checking = true;
  try {
    await detect();
  } finally {
    checking = false;
  }
}

async function detect(): Promise<void> {
  const remote = await fetchRemoteBuildId();
  if (!remote) return;
  if (remote !== __BUILD_ID__) {
    // 안내 뒤 첫 일반 새로고침이 새 번들을 받도록, 새 서비스워커가 활성화된 뒤에 안내한다.
    // 설치가 늦으면(느린 망) 지금 안내해도 새로고침이 옛 번들을 받으므로 안내를 미룬다.
    // 설치는 백그라운드에서 이어지고, 다음 확인(가시성 복귀·5분 주기)에서 다시 판단한다.
    if (!(await updateServiceWorker())) return;
    detected = true;
    window.dispatchEvent(new Event(VERSION_MISMATCH_EVENT));
  }
}

export function startVersionCheck(): void {
  if (started) return;
  if (!import.meta.env.PROD) return;
  if (typeof window === 'undefined') return;
  started = true;

  window.setTimeout(() => {
    void checkOnce();
  }, FIRST_CHECK_DELAY_MS);

  window.setInterval(() => {
    void checkOnce();
  }, POLL_INTERVAL_MS);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      void checkOnce();
    }
  });
}
